'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIList from 'UIComponents/list/UIList';

const ReviewActionsWrapper = ({
  className,
  children
}) => /*#__PURE__*/_jsx(UIList, {
  inline: true,
  use: "inline-divided",
  className: classNames(className, 'm-top-6'),
  children: children
});

ReviewActionsWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};
export default ReviewActionsWrapper;